import { persistState } from '../modules/persistence';
import { Middleware } from 'redux';
import { AppState } from '../redux/reducers';

const nextTick = require('next-tick');

const hydrationMiddleware: Middleware<{}, AppState> = (store) => (next) => (action) => {
  // make sure the action is run through completly before retrieving the store state
  next(action);

  nextTick(() => persistState(store.getState()));
};

export default hydrationMiddleware;
